import { PressableIcon } from '@bonanza-social/moonlight';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { memo, useCallback } from 'react';
import { CommunityJackpotNavigatorParamsList } from '../../navigators/CommunityJackpotNavigator.types';

function CommunityJackpotHeaderRight() {
  const navigation =
    useNavigation<StackNavigationProp<CommunityJackpotNavigatorParamsList>>();

  const onInfoPress = useCallback(() => {
    navigation.navigate('CommunityJackpotRulesScreen');
  }, [navigation]);

  return (
    <PressableIcon
      name="info"
      width="space-500"
      height="space-500"
      gradient="accentBackground"
      onPress={onInfoPress}
    />
  );
}

export default memo(CommunityJackpotHeaderRight);
